/* eslint-disable */

/* --------------- importing Images here --------------- */
import defaultUser from "assets/images/default-user.png";
import findelOiLogo from "assets/images/findeloi-logo.png";
import lobeesLogo from "assets/images/lobees-logo-blue.png";
import congratulationsIcon from "assets/images/congratulations-icon.png";
import successCheckPng from "assets/images/success-check-green.png";
import exclamationIcon from "assets/images/exclamation-icon.png";
import blankLogo from "assets/images/blanklogo.jpg";
import homeBannerImg from "assets/images/madrid-banner.jpg";
import appStoreImg from "assets/images/app-store.png";
import playStoreImg from "assets/images/play-store.png";
import expert1 from "assets/images/expert1.jpg";
import expert2 from "assets/images/expert2.jpg";
import expert3 from "assets/images/expert3.jpg";
import expert4 from "assets/images/expert4.jpg";
import expert5 from "assets/images/expert5.jpg";
import expert6 from "assets/images/expert6.jpg";
import partnerLogo1 from "assets/images/partner-logo1.png";
import partnerLogo2 from "assets/images/partner-logo2.png";
import partnerLogo3 from "assets/images/partner-logo3.png";
import partnerLogo4 from "assets/images/partner-logo4.png";
import partnerLogo5 from "assets/images/partner-logo5.png";
import qrCodeImage from "assets/images/qr.png";
import handsCalendar from "assets/images/hands-calender.png";
import handShake from "assets/images/no-network.png";
import noSpeaker from "assets/images/no-speaker.png";
import noPartner from "assets/images/no-partner.png";
import embedIcon from "assets/svg/code.svg";
import whatsAppIcon from "assets/svg/whatsapp.svg";
import skypIcon from "assets/svg/skype.svg";
import facebookIcon from "assets/svg/share-facebook.svg";
import twitterIcon from "assets/svg/share-twitter.svg";
import instagramIcon from "assets/svg/share-instagram.svg";

/* --------------- importing SVGs here --------------- */
import PdfImg from "assets/images/pdf.svg";
import PdfIcon from "assets/images/pdf-icon.svg";
import DocImg from "assets/images/docs.svg";
import XlsImg from "assets/images/xls.svg";
import VideoImg from "assets/images/video-icon.svg";
import submitTickSvg from "assets/images/submit-tick.svg";
import homeLogo from "assets/images/logo.svg";
import checkTick from "assets/images/check_circle.svg";
import alertInfo from "assets/images/alert.svg";

export default {
  // ------------------ Exporting Images here ------------------
  defaultUser,
  findelOiLogo,
  congratulationsIcon,
  lobeesLogo,
  successCheckPng,
  exclamationIcon,
  blankLogo,
  homeBannerImg,
  expert1,
  expert2,
  expert3,
  expert4,
  expert5,
  expert6,
  partnerLogo1,
  partnerLogo2,
  partnerLogo3,
  partnerLogo4,
  partnerLogo5,
  qrCodeImage,
  handsCalendar,
  handShake,
  noSpeaker,
  noPartner,

  // ------------------ Exporting SVGs here ------------------
  PdfImg,
  DocImg,
  XlsImg,
  VideoImg,
  PdfIcon,
  submitTickSvg,
  homeLogo,
  appStoreImg,
  playStoreImg,
  checkTick,
  alertInfo,
  embedIcon,
  whatsAppIcon,
  skypIcon,
  facebookIcon,
  twitterIcon,
  instagramIcon,
};
